import { Effect } from "@/modules/effects/domain/Effect";
import { EffectListScreenData } from "@/modules/effects/domain/EffectListScreenData";

export class VueEffectListScreenData implements EffectListScreenData{
    effects: Effect[];
    loading: boolean;
    importEffectsJobId: number;
    importEffectsJobState: string;
    loadingImportEffects:boolean;
    loadingImportEffectsAccountingProgram:boolean;
    loadingUpdateConfiguration:boolean;
    selectedEffects: Effect[];
    effectsOriginConfig: string;
    automaticEffectsInmaticConfig: boolean;
    showSelectEffects:boolean;
    snackbar: Object
    loadingUploadEffects: boolean;
    file: any;
    error_upload_file: boolean;
    error_message_upload_file: string;
    dialog_upload_excel:boolean;
    dialog_configuration: boolean;
    dialog_create_effect_manual: boolean;
    loadingCreateEffect: boolean;    
    new_effect: Effect;

    constructor(){
        this.effects = []
        this.selectedEffects = []        
        this.loading = false        
        this.importEffectsJobId = 0
        this.importEffectsJobState = 'done'
        this.loadingImportEffects = false
        this.loadingImportEffectsAccountingProgram = false
        this.loadingUpdateConfiguration = false
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
        }
        this.loadingUploadEffects = false
        this.file=null
        this.error_upload_file = false
        this.error_message_upload_file = ''
        this.dialog_upload_excel = false
        this.dialog_configuration = false
        this.effectsOriginConfig = 'inmatic'
        this.automaticEffectsInmaticConfig = false
        this.dialog_create_effect_manual = false
        this.loadingCreateEffect = false
        this.new_effect = new Effect(0, "", null, 0, "", 0, "no_punteado", "", "payable_effect", "", "", "manual", false, "")        
    }
    
    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading){
        this.loading = loading;
    }

    setEffects(effects_data){
        this.effects = effects_data;
    }

    setImportEffectsJobId(job_id) {
        this.importEffectsJobId = job_id;    
    }
    setImportEffectsJobState(state) {
        this.importEffectsJobState = state;
    }
    setLoadingImportEffects(loading) {
        this.loadingImportEffects = loading;
    }
    setShowSelectEffects(value) {
        this.showSelectEffects = value
    }
    setLoadingImportEffectsAccountingProgram(loading) {
        this.loadingImportEffectsAccountingProgram = loading;
    }

    setLoadingUploadEffects(loading: boolean): void {
        this.loadingUploadEffects = loading;
    }
    
    setErrorUploadFile(error: any): void {
        this.error_upload_file = error;
    }

    setErrorMessageUploadFile(message: any): void {
        this.error_message_upload_file = message;
    }

    setEffectsOriginConfig(value: any): void {
        this.effectsOriginConfig = value;
    }

    setAutomaticEffectsInmaticConfig(value: any): void {
        this.automaticEffectsInmaticConfig = value;
    }

    setLoadingUpdateConfiguration(value):void {
        this.loadingUpdateConfiguration = value;
    }
    setLoadingCreateEffect(value):void {
        this.loadingCreateEffect = value;
    }
    resetNewEffect():void {
        this.new_effect = new Effect(0, "", null, 0, "", 0, "no_punteado", "", "payable_effect", "", "", "manual", false, "")
    }
}